import React, { ReactElement } from 'react'
import { PaymentMethodsEnum } from './enums/payment-methods'
import {
  IconPaymentBoleto,
  IconPaymentVisa,
  IconPaymentMasterCard,
  IconPaymentDinersClub,
  IconPaymentDiscover,
  IconPaymentElo,
  IconPaymentAmericanExpress,
  IconPix,
} from '@gazin/ecommerce-ui'

export const paymentMethodsIconsMap: Record<
  string,
  ReactElement | ReactElement[]
> = {
  [PaymentMethodsEnum.Billet]: (
    <IconPaymentBoleto
      key={PaymentMethodsEnum.Billet}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />
  ),
  [PaymentMethodsEnum.Credit_card]: [
    <IconPaymentVisa
      key={`${PaymentMethodsEnum.Credit_card}-visa`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
    <IconPaymentMasterCard
      key={`${PaymentMethodsEnum.Credit_card}-martercard`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
    <IconPaymentDinersClub
      key={`${PaymentMethodsEnum.Credit_card}-dinersclub`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
    <IconPaymentDiscover
      key={`${PaymentMethodsEnum.Credit_card}-discover`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
    <IconPaymentElo
      key={`${PaymentMethodsEnum.Credit_card}-elo`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
    <IconPaymentAmericanExpress
      key={`${PaymentMethodsEnum.Credit_card}-americanexpress`}
      width="2.382rem"
      backgroundColor="#fff"
      borderRadius="5"
    />,
  ],
  [PaymentMethodsEnum.Pix]: (
    <IconPix
      key={PaymentMethodsEnum.Pix}
      width="2.382rem"
      backgroundColor="#fff"
      color="grey.100"
      borderRadius="5"
    />
  ),
}
